import { AfterContentInit, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { take } from 'rxjs/operators';
import { PropostaStatusEnum } from 'src/app/domain/enums/proposta-status.enum';
import { TipoUsuario } from 'src/app/domain/enums/tipo-usuario.enum';
import { HomeMetricas } from 'src/app/domain/models/home-metricas.model';
import { AccessProfileService } from 'src/app/domain/services/access-profile.service';
import { LoginService } from 'src/app/domain/services/login.service';
import { MetricasService } from 'src/app/domain/services/metricas.service';
import { UserService } from 'src/app/domain/services/user.service';
import { LoadComponent } from 'src/app/ui/load/load.component';

@Component({
  selector: 'app-metricas-slider',
  templateUrl: './metricas-slider.component.html',
  styleUrls: ['./metricas-slider.component.scss']
})
export class MetricasSliderComponent implements OnInit, AfterContentInit {

  @ViewChild('carouselTomador') carouselTomador: NguCarousel<any>;
  @ViewChild('carouselPropostas') carouselPropostas: NguCarousel<any>;

  carouselConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 2, lg: 2, all: 0 },
    load: 2,
    interval: {timing: 4000, initialDelay: 1000},
    loop: false,
    touch: true,
    velocity: 0.2,
    point: {
      visible: true,
      hideOnSingleSlide: false
    }
  }
  carouselItemsTomador = [];
  carouselItemsPropostas = [];

  exibirAlerta: boolean = false;
  private token: string;
  private decoded: any;
  email: string;
  public homeMetricas: HomeMetricas;
  public tomador: boolean = true;
  public showTomador: boolean = true;
  public propostas: boolean = true;
  public vinculoCorretora: boolean = false;
  propostaStatus = PropostaStatusEnum;
  showMetricas: boolean = true;
  screenLoading: boolean = false;

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private metricasService: MetricasService,
    private dialog: MatDialog,
    private accessProfileService: AccessProfileService,
    private router: Router
  ) { }


  async ngAfterContentInit() {
    await this.loadUserData();
  }

  ngOnInit() {
    this.setMetricasLoading();
    this.loadPermissions();
  }

  async loadUserData(){
    this.token = localStorage.getItem('token');
    this.decoded = this.loginService.decodeToken(this.token);
    const userData = await this.userService.getLoggedUser().pipe(take(1)).toPromise();
    localStorage.setItem("userdata", JSON.stringify(userData));
    this.getExpireMetricas(this.decoded.id);
    
    var itemMetricasCache = localStorage.getItem(this.decoded.id + "_" +"metricas");
    if(userData.data.userTypeId === TipoUsuario.Assessoria){
      this.showMetricas = false;
    }
    if(userData.data.brokerId){
      this.vinculoCorretora = true;
    } 
    if(!itemMetricasCache){
      var requestLoadMetricas = {
        'IdCorretoraVinculo': userData.data.brokerId,
        'IdTomadorVinculo': userData.data.takerId
      }
      if(this.showMetricas){
        this.screenLoading = true;
        await this.metricasService.postLoadMetricas(requestLoadMetricas).pipe(take(1)).toPromise().then(res => {
          this.carouselItemsTomador = [];
          this.carouselItemsPropostas = [];
          this.homeMetricas = res;
          Object.keys(this.homeMetricas.metricasTomadores).forEach(t =>{
            this.carouselItemsTomador.push({
              metricaTomador: this.homeMetricas.metricasTomadores[t],
              metricaSubTitulo: this.obterMetricaSubtituloTomador(t),
              idPesquisa: this.obterIdTomadorPesquisa(t)
            });
          });
    
          Object.keys(this.homeMetricas.metricasPropostas).forEach(t =>{
            this.carouselItemsPropostas.push({
              metricaProposta: this.homeMetricas.metricasPropostas[t],
              metricaSubTitulo: this.obterMetricaSubtituloPropostas(t),
              idPesquisa: this.obterIdPropostasPesquisa(t)
            });
          });
          this.screenLoading = false;
        });
      }
      this.setLocalStorageMetricas(this.decoded.id, this.homeMetricas);
    }else{
      this.homeMetricas = JSON.parse(itemMetricasCache);
      Object.keys(this.homeMetricas.metricasTomadores).forEach(t =>{
        this.carouselItemsTomador.push({
          metricaTomador: this.homeMetricas.metricasTomadores[t],
          metricaSubTitulo: this.obterMetricaSubtituloTomador(t),
          idPesquisa: this.obterIdTomadorPesquisa(t)
        });
      });

      Object.keys(this.homeMetricas.metricasPropostas).forEach(t =>{
        this.carouselItemsPropostas.push({
          metricaProposta: this.homeMetricas.metricasPropostas[t],
          metricaSubTitulo: this.obterMetricaSubtituloPropostas(t),
          idPesquisa: this.obterIdPropostasPesquisa(t)
        });
      });
    }
    // loadRef.close();
  }

  obterIdTomadorPesquisa(metrica: string): number{
    let idPesquisa: number = 0;

    switch(metrica){
      case 'totalTomadores':
        idPesquisa = 1;
        break;
      case 'totalTomadoresCadastroVencido':
        idPesquisa = 2;
        break;
      case 'totalTomadoresLimiteExcedido':
        idPesquisa = 4;
        break;
      case 'totalTomadoresSemEmissao':
        idPesquisa = 3;
        break;
    }

    return idPesquisa;
  }

  obterIdPropostasPesquisa(metrica: string): number{
    let idPesquisa: number = 0;

    switch(metrica){
      case 'totalPropostasEmAnalise':
        idPesquisa = this.propostaStatus.EmAnalise;
        break;
      case 'totalPropostasEmNegociacao':
        idPesquisa = this.propostaStatus.EmNegociacao;
        break;
      case 'totalPropostasEmitidas':
        idPesquisa = this.propostaStatus.Emitida;
        break;
      case 'totalPropostasRecusadas':
        idPesquisa = this.propostaStatus.Recusada;
        break;
      case 'totalPropostasCadastradasUltimaSemana':
        idPesquisa = 0;
        break;
    }

    return idPesquisa;
  }

  obterMetricaSubtituloTomador(metrica: string): string{
    let metricaSubtitulo: string = '';

    switch(metrica){
      case 'totalTomadores':
        metricaSubtitulo = 'Cadastrados';
        break;
      case 'totalTomadoresCadastroVencido':
        metricaSubtitulo = 'Cadastro Vencido';
        break;
      case 'totalTomadoresLimiteExcedido':
        metricaSubtitulo = 'com Limite Atingido';
        break;
      case 'totalTomadoresSemEmissao':
        metricaSubtitulo = 'Sem Emissão';
        break;
    }

    return metricaSubtitulo;
  }

  obterMetricaSubtituloPropostas(metrica: string): string{
    let metricaSubtitulo: string = '';

    switch(metrica){
      case 'totalPropostasEmAnalise':
        metricaSubtitulo = 'Em Análise';
        break;
      case 'totalPropostasEmNegociacao':
        metricaSubtitulo = 'Em Negociação';
        break;
      case 'totalPropostasEmitidas':
        metricaSubtitulo = 'Emitidas';
        break;
      case 'totalPropostasRecusadas':
        metricaSubtitulo = 'Recusadas';
        break;
      case 'totalPropostasCadastradasUltimaSemana':
        metricaSubtitulo = 'Cadastradas nas Últimas Semanas';
        break;
    }

    return metricaSubtitulo;
  }

  setLocalStorageMetricas(id: any, metricas: HomeMetricas){
    if(metricas != null){
      localStorage.setItem(this.decoded.id + "_" +"metricas", JSON.stringify(this.homeMetricas));
      var date = new Date();
      date.setHours(date.getHours() + 1);
      localStorage.setItem("exp_metricas", JSON.stringify(date.toString().replace('"','').replace('"','')));
    }
  }

  getExpireMetricas(id: any){
    var expMetricas = localStorage.getItem("exp_metricas");

    if(expMetricas != null){
      var dataExpiracao = new Date(expMetricas);
      var dataAtual = new Date();

      if(dataExpiracao < dataAtual)
        localStorage.removeItem(this.decoded.id + "_" +"metricas");
    }else{
        localStorage.removeItem(this.decoded.id + "_" +"metricas");
    }
  }

   async loadPermissions(){
    this.tomador = (await this.accessProfileService.getProfiliesClaimLink("Consulta%20e%20Cadastro%20de%20Tomador")).data.item1 ? true :   false;
    this.propostas = (await this.accessProfileService.getProfiliesClaimLink("Consulta%20e%20Cadastro%20de%20Propostas%20e%20Emiss%C3%B5es")).data.item1 ? true :   false;

    const userData = JSON.parse(localStorage.getItem('userdata'));
    if(userData.data.takerId){
      this.showTomador = false;
    }
  }

  redirectTo(tipoMetrica, status = null){
    let statePayload;
    if(tipoMetrica === 'propostas'){
      const userData = JSON.parse(localStorage.getItem('userdata'));
      statePayload = {
        brokerId: userData.data.brokerId,
        takerId: userData.data.takerId,
        status: status,
        lastWeek: status ? false : true
      }
      this.router.navigate(['propostas/consultar'], { queryParams: statePayload, state: { fromMetrica: true} } );
    }else if(tipoMetrica === 'tomador'){
      const userData = JSON.parse(localStorage.getItem('userdata'));
      statePayload = {
        brokerId: userData.data.brokerId,
        takerId: userData.data.takerId,
        tipo: status
      }
      this.router.navigate(['tomador/consultar'], { queryParams: statePayload, state: { fromMetrica: true} } );
    }
  }

  setMetricasLoading(): void{
    this.carouselItemsTomador.push(
      {
        metricaTomador: '',
        metricaSubTitulo: 'Cadastrados',
        idPesquisa: ''
      },
      {
        metricaTomador: '',
        metricaSubTitulo: 'Cadastro Vencido',
        idPesquisa: ''
      },
      {
        metricaTomador: '',
        metricaSubTitulo: 'Sem Emissão',
        idPesquisa: ''
      },
      {
        metricaTomador: '',
        metricaSubTitulo: 'com Limite Atingido',
        idPesquisa: ''
      }
    );
    this.carouselItemsPropostas.push(
      {
        metricaProposta: '',
        metricaSubTitulo: 'em análise',
        idPesquisa: ''
      },
      {
        metricaProposta: '',
        metricaSubTitulo: 'em negociação',
        idPesquisa: ''
      },
      {
        metricaProposta: '',
        metricaSubTitulo: 'Emitidas',
        idPesquisa: ''
      },
      {
        metricaProposta: '',
        metricaSubTitulo: 'Recusadas',
        idPesquisa: ''
      },
      {
        metricaProposta: '',
        metricaSubTitulo: 'cadastradas na última semana',
        idPesquisa: ''
      }
    )
  }
}
